// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bhk_wv bhk_iz bhk_xj bhk_i bhk_j bhk_q bhk_vr bhk_er bhk_sm bhk_sn bhk_eb","CommentsButton__icon":"il_b bhk_rx"};